import { render, staticRenderFns } from "./AllFinalBulletin.vue?vue&type=template&id=20f0784c&"
import script from "./AllFinalBulletin.vue?vue&type=script&lang=js&"
export * from "./AllFinalBulletin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports